module.exports = __webpack_public_path__ + "img/image.cb8e3f12.svg";